@if ((loading$ | async) === true) {
  <div class="spinner relative top-40 m-auto h-32 w-32 border-8"></div>
} @else {
  <div class="mb-4 flex justify-end">
    @if ((editModeGrid$ | async) === false) {
      <aux-button variant="secondary" label="Edit" icon="Pencil" [onClick]="editGrid.bind(this)" />
    }

    @if ((editModeGrid$ | async) === true) {
      <aux-button
        variant="secondary"
        label="Cancel"
        icon="X"
        [onClick]="cancelEditMode.bind(this)"
      />
    }

    @if ((editModeGrid$ | async) === true) {
      <aux-button
        variant="success"
        label="Save"
        class="ml-1"
        icon="Check"
        [disabled]="!hasChanges"
        [onClick]="onSaveAll"
      />
    }

    <aux-export-excel-button
      [className]="'ml-1'"
      [gridAPI]="gridAPI"
      [getDynamicExcelParamsCallback]="getDynamicExcelParams.bind(this)"
      pendoTag="patient-groups-excel-export-button"
    />
  </div>

  <ag-grid-angular
    class="ag-theme-aux"
    id="patientGroupsGrid"
    [rowData]="(gridData$ | async)!"
    [gridOptions]="(gridOptions$ | async)!"
    [enableFillHandle]="(editModeGrid$ | async) === true"
    (gridReady)="onGridReady($event)"
    (cellValueChanged)="cellValueChanged($event)"
    (cellEditingStopped)="cellEditingStopped($event)"
    (rowDragEnd)="onRowDragEnd($event)"
    (gridSizeChanged)="sizeColumnsToFit()"
  />

  <div class="mt-4">
    @if ((editModeGrid$ | async) === true) {
      <aux-button
        variant="primary"
        label="Add Patient Group"
        [onClick]="onAddPatientGroups.bind(this)"
      />
    }
  </div>
}
